import { requisitarJson } from '../../../shared/api/http';

export type Destino = 'grupo' | 'individual';
export type ValorDaRegra = number | Destino;

export interface RegrasDaFase {
    fase: string;
    /** Pontos (inteiros) e destinos, já com os padrões aplicados. */
    regras: Record<string, ValorDaRegra>;
    editavel: boolean;
    turmas_com_fase_aberta: string[];
}

export function listarRegras(): Promise<RegrasDaFase[]> {
    return requisitarJson('/api/v1/pontuacao');
}

export function alterarRegra(fase: string, chave: string, valor: ValorDaRegra, csrfToken: string): Promise<RegrasDaFase> {
    return requisitarJson(`/api/v1/pontuacao/${encodeURIComponent(fase)}`, {
        method: 'PATCH', csrfToken, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ chave, valor }),
    });
}
